/**
 * @generated SignedSource<<91259e181935caa218705349ca895690>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStakingType = "FLEXIBLE" | "LOCKED";
export type StakeInput = {
  assetAmount: any;
  assetId: string;
};
export type StakingRewardViewQuery$variables = {
  input?: StakeInput | null | undefined;
};
export type StakingRewardViewQuery$data = {
  readonly stakingReward: {
    readonly __typename: "StakingEstimatedReward";
    readonly asset: {
      readonly __typename: string;
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly portfolio: {
        readonly assetBalance: PrecisionFloat | null | undefined;
        readonly fiatBalance: PrecisionFloat | null | undefined;
      } | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly staking?: {
        readonly minimumStakeableAmount: PrecisionFloat | null | undefined;
        readonly rewardIntervalInDays: number | null | undefined;
        readonly type: AssetStakingType | null | undefined;
        readonly unboundedPeriodInDays: number | null | undefined;
        readonly yearlyInterest: number | null | undefined;
      } | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly assetAmount: PrecisionFloat;
    readonly assetReward: PrecisionFloat | null | undefined;
    readonly nextRewardAt: TimeScalar | null | undefined;
  } | null | undefined;
};
export type StakingRewardViewQuery = {
  response: StakingRewardViewQuery$data;
  variables: StakingRewardViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StakingEstimatedReward",
    "kind": "LinkedField",
    "name": "stakingReward",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetBalance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatBalance",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetStaking",
                "kind": "LinkedField",
                "name": "staking",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rewardIntervalInDays",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unboundedPeriodInDays",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "yearlyInterest",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minimumStakeableAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "CryptoAsset",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetReward",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextRewardAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StakingRewardViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StakingRewardViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0f92278c13284305f83649500ade47f2",
    "id": null,
    "metadata": {},
    "name": "StakingRewardViewQuery",
    "operationKind": "query",
    "text": "query StakingRewardViewQuery(\n  $input: StakeInput\n) {\n  stakingReward(input: $input) {\n    __typename\n    asset {\n      __typename\n      id\n      logoUrl\n      price\n      name\n      symbol\n      portfolio {\n        assetBalance\n        fiatBalance\n      }\n      ... on CryptoAsset {\n        staking {\n          rewardIntervalInDays\n          type\n          unboundedPeriodInDays\n          yearlyInterest\n          minimumStakeableAmount\n        }\n      }\n    }\n    assetAmount\n    assetReward\n    nextRewardAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e05abfc2c14d73b0b4ae3720b22635f";

export default node;
